import { createContext, useContext } from "react";

import type { ThemeConfig } from "./theme-types";

export const ThemeContext = createContext<ThemeConfig | undefined>(undefined);

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}

export function useOptionalTheme() {
  return useContext(ThemeContext);
}
